import script from "./AttentionTextDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttentionTextDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./AttentionTextDisplay.vue?vue&type=style&index=0&id=1d612758&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d612758"]])

export default __exports__